import { Link } from "@tanstack/react-router";
import { useRecentlyViewed } from "@/hooks/use-recently-viewed";
import { KIND_LABEL } from "@/lib/ecosystem";

interface Props {
  limit?: number;
  heading?: string;
  /** Optional slug to filter out (e.g. current page). */
  excludeSlug?: string;
}

/** Client-only "Continue exploring" rail from localStorage. Renders nothing empty. */
export function RecentlyViewedRail({ limit = 6, heading = "Continue exploring", excludeSlug }: Props) {
  const items = useRecentlyViewed(limit + 1).filter((i) => i.slug !== excludeSlug).slice(0, limit);
  if (items.length === 0) return null;

  return (
    <section aria-label={heading} className="mt-16" data-reveal="up">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Where you have been</p>
      <h2 className="mt-2 font-serif text-2xl sm:text-3xl">{heading}</h2>
      <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((i) => (
          <li key={`${i.kind}:${i.slug}`}>
            <Link
              to={i.href}
              className="card-luxe hover-lift block rounded-2xl border hairline bg-charcoal/40 p-5"
            >
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold">{KIND_LABEL[i.kind]}</p>
              <p className="mt-2 font-serif text-lg text-ivory group-hover:text-gold-luminous">{i.title}</p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
